import React from "react";
import "../../../css/DesignSystem/Buttons/ButtonPrimarySmall.css";

const ButtonPrimarySmall = ({ children, onClick, disabled, buttonText }) => {
  return (
    <button
      className={`button-primary-small ${disabled ? "disabled" : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="Button-Text-Medium">{buttonText}</div>
      {children}
    </button>
  );
};

export default ButtonPrimarySmall;
